import { render } from "./AdminSign.vue?vue&type=template&id=562bb048&scoped=true"
const script = {}

import "./AdminSign.vue?vue&type=style&index=0&id=562bb048&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/user.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562bb048"]])

export default __exports__